import { computed, type ComputedRef } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import type { MenuItemWithRelatedPaths } from '@cplug/frontend-core/composables'
import { BaseIconName } from '@cplug/design-system/components/props'
import { isOnlineStoreMenuEnabled, isOnlineStoreRoute } from './isOnlineStoreMenuEnabled'
import { useMenuAppContextsTranslation } from './useMenuAppContexts.i18n'
import { useActiveProductContext } from '~/domain/shared/product-apps/composables/useActiveProductContext'
import { COMING_SOON_PRODUCT_PATHS } from '~/domain/shared/product-apps/models/ComingSoonProduct'
import { useBrandTheme } from '~/domain/shared/branding/composables/useBrandTheme'

export function useMenuAppContexts (): { appContexts: ComputedRef<MenuItemWithRelatedPaths[]> } {
  const router = useRouter()
  const route = useRoute()
  const { t } = useMenuAppContextsTranslation()
  const { name } = useActiveProductContext()
  const { isBagy, isTray } = useBrandTheme()
  const isTrayOrBagy = computed(() => isBagy.value || isTray.value)
  const isStoreRoute = computed(() => isOnlineStoreRoute(route.path))

  const appContexts = computed<MenuItemWithRelatedPaths[]>(() => {
    const contexts: MenuItemWithRelatedPaths[] = [
      {
        command: (): void => {
          router.push('/dashboard/')
        },
        exactMatch: name.value !== 'erp' || isStoreRoute.value,
        icon: BaseIconName.Desktop,
        label: t('ErpApp'),
        name: 'erp',
        path: '/dashboard/'
      }
    ]

    if (isOnlineStoreMenuEnabled()) {
      contexts.push({
        command: (): void => {
          router.push('/dashboard/store/general')
        },
        icon: BaseIconName.Shop,
        label: t('OnlineStoreApp'),
        name: 'store',
        path: '/dashboard/store'
      })
    }

    if (isTrayOrBagy.value) {
      return contexts
    }

    if (!isOnlineStoreMenuEnabled()) {
      contexts.push({
        command: (): void => {
          router.push(COMING_SOON_PRODUCT_PATHS.loja)
        },
        icon: BaseIconName.ShoppingCart,
        label: t('StoreApp'),
        name: 'loja',
        path: COMING_SOON_PRODUCT_PATHS.loja
      })
    }

    contexts.push({
      command: (): void => {
        router.push(COMING_SOON_PRODUCT_PATHS.pagamentos)
      },
      icon: BaseIconName.CreditCard,
      label: t('PaymentsApp'),
      name: 'pagamentos',
      path: COMING_SOON_PRODUCT_PATHS.pagamentos
    })

    return contexts
  })

  return { appContexts }
}
